import { ErrorBoundary, LoadingSpinner, ErrorDisplay } from '../../shared/components'
import AppHeader from '../../shared/components/AppHeader'
import { useApiQuery } from '../../shared/hooks'
import { SummaryData } from '../../../../shared/types'
import NetWorthSummary from './components/NetWorthSummary'
import AccountsList from '../accounts/components/AccountsList'
import TrendChart from './components/TrendChart'

export default function DashboardPage() {
  const {
    data: summaryData,
    isLoading,
    error,
    refetch
  } = useApiQuery<SummaryData>(
    ['dashboard', 'summary'],
    '/dashboard/summary',
    {
      refetchInterval: 30000, // Refetch every 30 seconds for real-time updates
      staleTime: 10000, // Consider data stale after 10 seconds
    }
  )

  const formatLastUpdated = () => {
    return new Date().toLocaleString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true
    })
  }

  return (
    <ErrorBoundary>
      <AppHeader />
      <div className="container">
        <header>
          <h1>My Net Worth Tracker</h1>
          <p>A simple overview of my financial health. Last updated: {formatLastUpdated()}</p>
        </header>

        <main>
          {isLoading && (
            <div className="loading">
              <LoadingSpinner />
            </div>
          )}

          <ErrorDisplay
            error={error}
            title="Failed to Load Dashboard"
            showRetry={true}
            onRetry={() => refetch()}
          />

          {summaryData && (
            <>
              {/* Summary Section */}
              <section className="summary-section">
                <h2>Overall Summary</h2>
                <NetWorthSummary
                  summaryData={summaryData}
                  isLoading={isLoading}
                  error={error}
                  onRetry={() => refetch()}
                />
              </section>

              {/* Accounts Breakdown */}
              <section className="accounts-section">
                <h2>Accounts</h2>
                <AccountsList />
              </section>

              {/* Trend Chart Section */}
              <section className="trend-section">
                <h2>Net Worth Trend (YTD)</h2>
                <TrendChart />
              </section>
            </>
          )}
        </main>
      </div>
    </ErrorBoundary>
  )
}